module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNzBhMTY5MTIxZmQ2ZWIwZjhjNmY2NjAyOTUzMGYyMGMucG5nIjs="